/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth



(function ($) {
  Drupal.behaviors.slider1 = {
    attach: function (context) {
      'use strict';

      /**
       * Slider Bg
       */
      $('.slick-blk .node .field--name-field-featured-image').once().each(function() {
        $(this).css('background-image', 'url(' + $(this).find('img').attr('src') + ')');
      });
    }
  }

})(jQuery);
